import {
    IntentKind,
    makeIntentBuilderFunction,
    type PaginationIntent,
} from '@jet-app/music-classical/intents';

export const makeBrowseDetailPaginationIntent =
    makeIntentBuilderFunction<PaginationIntent>(
        IntentKind.BROWSE_DETAIL_PAGINATION,
    );
